import React from "react";
import { Container } from "reactstrap";
import styles from "./QuemSomos.module.css";

const QuemSomos = () => {
    return (
        <Container>

            <section className={styles.section}>
                <h2 className={styles.sectionTitlePrimary}>Nossa Missão</h2>
                <p className={styles.sectionContent}>
                    Na GuardAÍ, inovamos com o compromisso de trazer soluções de armazenagem inteligentes e seguras que integram tecnologia de ponta e design funcional. Nosso objetivo é transformar a maneira como objetos são armazenados, oferecendo mais conveniência e segurança para empresas e consumidores.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitlePrimary}>Sobre Nós</h2>
                <p className={styles.sectionContent}>
                    A GuardAÍ é a primeira empresa especializada em armários inteligentes no Nordeste do Brasil. Localizada estrategicamente para melhor atender a região, somos movidos pela paixão em tecnologia e pelo desejo de oferecer produtos inovadores que atendam as necessidades modernas de armazenagem e segurança.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitlePrimary}>Nosso Produto</h2>
                <p className={styles.sectionContent}>
                    Nossos armários inteligentes são projetados para serem extremamente funcionais e adaptáveis. Com design modular, eles podem ser configurados em diferentes tamanhos e formatos, adequando-se perfeitamente aos espaços e às necessidades específicas de cada cliente. Cada unidade é equipada com a mais recente tecnologia IoT, permitindo controle e gestão remotos, garantindo assim uma operação segura e eficiente.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitlePrimary}>Inovação e Tecnologia</h2>
                <ul className={styles.list}>
                    <li><strong>Segurança Avançada:</strong> Nossos armários utilizam codificação de última geração e sistemas de logs detalhados para uma segurança robusta de seus conteúdos.</li>
                    <li><strong>Conectividade e Automação:</strong> Graças à tecnologia IoT, nossos armários inteligentes conectam-se à nuvem, proporcionando uma gestão simplificada e automação completa dos processos de armazenagem.</li>
                    <li><strong>Facilidade de Uso:</strong> Projetados para operar de forma autônoma, os armários requerem apenas uma conexão de energia e internet, facilitando sua implementação em qualquer local.</li>
                    <li><strong>Compromisso com a Qualidade:</strong> Na GuardAÍ, cada armário é cuidadosamente produzido e testado para atender aos mais altos padrões de qualidade. Nossa equipe é treinada para garantir a melhor instalação e suporte técnico, assegurando que cada cliente tenha a melhor experiência desde o primeiro contato.</li>
                </ul>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleCenter}>Venha Conhecer a GuardAÍ</h2>
                <p className={styles.sectionContent}>
                    Convidamos você a explorar como os armários inteligentes da GuardAÍ podem revolucionar a gestão de armazenagem em seu negócio. Estamos prontos para atender suas necessidades específicas com soluções inovadoras e personalizadas.
                </p>
            </section>
        </Container>
    );
};

export default QuemSomos;
